import { useTranslation } from 'react-i18next';
import { Bot } from 'lucide-react';

/** The "agent" mark next to an agent account's name (crates/server/src/api/agents.rs). */
export function AgentBadge() {
  const { t } = useTranslation();
  return (
    <span className="badge agent-badge">
      <Bot size={11} /> {t('agentAccounts.badge')}
    </span>
  );
}
